import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2cf13182"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "flex gap-2 mx-6 p-2 mb-4 bg-gray-200 rounded-md"
}
const _hoisted_3 = { class: "flex flex-col gap-2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 font-semibold" }, " Von Vorlage ", -1))
const _hoisted_5 = { class: "m-0 text-sm" }
const _hoisted_6 = { class: "flex flex-col gap-2 border-b" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 font-semibold" }, " Zur Vorlage ", -1))
const _hoisted_8 = { class: "m-0 text-sm" }
const _hoisted_9 = { class: "px-8" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Migration nicht erfolgreich ", -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "flex justify-between" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 3 }
const _hoisted_16 = {
  key: 0,
  class: "mb-0 mx-4 bg-gray-200 rounded-md p-2"
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 4 }
const _hoisted_19 = {
  key: 0,
  class: "mx-4"
}
const _hoisted_20 = { class: "m-4" }
const _hoisted_21 = { class: "flex-1" }
const _hoisted_22 = { class: "flex-1" }
const _hoisted_23 = { class: "flex-1" }
const _hoisted_24 = { class: "m-4 block md:flex" }
const _hoisted_25 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HzbaBaseInput = _resolveComponent("HzbaBaseInput")!
  const _component_hzba_group = _resolveComponent("hzba-group")!
  const _component_info_banner = _resolveComponent("info-banner")!
  const _component_AButton = _resolveComponent("AButton")!
  const _component_ba_all_differences = _resolveComponent("ba-all-differences")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_progress_indicator = _resolveComponent("progress-indicator")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_PdfTemplates = _resolveComponent("PdfTemplates")!
  const _component_PdfPreviewerAndCreator = _resolveComponent("PdfPreviewerAndCreator")!

  return (_ctx.ba)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.immobilie)
          ? (_openBlock(), _createBlock(_component_hzba_group, {
              key: 0,
              title: _ctx.t('hzba.uebersicht.titel'),
              "hide-progress": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_HzbaBaseInput, {
                  "model-value": _ctx.immobilie?.externeObjektNr,
                  label: _ctx.t(`${_ctx.organisationPrefix}hzba.objektdaten.objektnummerTitel`),
                  "hide-unit-space": "",
                  readonly: "",
                  "flat-mode": ""
                }, null, 8, ["model-value", "label"]),
                _createVNode(_component_HzbaBaseInput, {
                  "model-value": _ctx.translatedHzbaStatus(_ctx.ba?.status, _ctx.t),
                  label: "Status",
                  "hide-unit-space": "",
                  readonly: ""
                }, null, 8, ["model-value"]),
                _createVNode(_component_HzbaBaseInput, {
                  label: _ctx.t('hzba.uebersicht.zugeordneterGutachter'),
                  "hide-unit-space": "",
                  readonly: "",
                  "flat-mode": "",
                  "model-value": _ctx.ba?.gutachter?.username
                }, null, 8, ["label", "model-value"])
              ]),
              _: 1
            }, 8, ["title"]))
          : _createCommentVNode("", true),
        _createVNode(_component_hzba_group, {
          title: _ctx.t('hzba.vorschau.fortschrittTitel'),
          "hide-progress": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_HzbaBaseInput, {
              label: _ctx.t('hzba.vorschau.felderAusgefuellt'),
              "model-value": `${_ctx.totalProgress}%`,
              "hide-unit-space": "",
              readonly: "",
              "flat-mode": ""
            }, null, 8, ["label", "model-value"])
          ]),
          _: 1
        }, 8, ["title"]),
        (_ctx.upgradeAvailable)
          ? (_openBlock(), _createBlock(_component_hzba_group, {
              key: 1,
              title: 'Migiriere Bestandsaufnahme',
              class: "relative",
              "hide-progress": ""
            }, {
              default: _withCtx(() => [
                (_ctx.migrationFromTo && Object.keys(_ctx.migrationFromTo).length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.migrationFromTo?.fromVorlage), 1)
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.migrationFromTo?.toVorlage), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_9, [
                  (!_ctx.migrationSuccessfull)
                    ? (_openBlock(), _createBlock(_component_info_banner, {
                        key: 0,
                        class: "mb-4",
                        "no-extra-margin": ""
                      }, {
                        default: _withCtx(() => [
                          _hoisted_10,
                          (_ctx.migrationStatusText != '')
                            ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.migrationStatusText), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.baUnsolvedMigrations, (unsolvedMigration, key) => {
                              return (_openBlock(), _createElementBlock("div", { key: key }, [
                                _createElementVNode("pre", null, _toDisplayString(unsolvedMigration.migrationDescription), 1),
                                _createElementVNode("div", null, _toDisplayString(unsolvedMigration.onFailDescription), 1)
                              ]))
                            }), 128))
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_AButton, {
                      "btn-secondary": true,
                      onClick: _cache[0] || (_cache[0] = () => _ctx.getMigrateBa(_ctx.ba, false))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Änderungen durchführen ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AButton, {
                      "btn-secondary": true,
                      onClick: _cache[1] || (_cache[1] = () => _ctx.getMigrateBa(_ctx.ba, true))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Änderungen anschauen ")
                      ]),
                      _: 1
                    })
                  ])
                ]),
                (_ctx.baDifferences && Object.keys(_ctx.baDifferences).length > 0)
                  ? (_openBlock(), _createBlock(_component_ba_all_differences, {
                      key: 1,
                      "ba-differences": _ctx.baDifferences
                    }, null, 8, ["ba-differences"]))
                  : _createCommentVNode("", true),
                (_ctx.baDifferences && Object.keys(_ctx.baDifferences).length > 0)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: "text-sm mx-4 mt-2 p-2 bg-gray-200 cursor-pointer rounded-md",
                      onClick: _cache[2] || (_cache[2] = () => _ctx.showDifferencesJson = !_ctx.showDifferencesJson)
                    }, [
                      (!_ctx.showDifferencesJson)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, " show "))
                        : (_openBlock(), _createElementBlock("span", _hoisted_14, " hide ")),
                      _createTextVNode(" all Differences JSON ")
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showDifferencesJson)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      (_ctx.baDifferences && Object.keys(_ctx.baDifferences).length > 0)
                        ? (_openBlock(), _createElementBlock("pre", _hoisted_16, "                    " + _toDisplayString(_ctx.baDifferences) + "\n                  ", 1))
                        : (_openBlock(), _createElementBlock("p", _hoisted_17, " No differences "))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.baUnsolvedMigrations && _ctx.baUnsolvedMigrations.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("pre", null, _toDisplayString(_ctx.baUnsolvedMigrations), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.ba?.isInProgress())
          ? (_openBlock(), _createBlock(_component_hzba_group, {
              key: 2,
              title: _ctx.t('hzba.vorschau.pdfVorschauTitel'),
              "hide-progress": ""
            }, {
              cta: _withCtx(() => [
                _createVNode(_component_AButton, {
                  "btn-secondary": true,
                  disabled: !_ctx.ba?.hasPdfSupport(),
                  shape: "round",
                  fill: "flat",
                  expand: _ctx.isMaxSmall ? 'full' : 'block',
                  class: _normalizeClass(_ctx.isMaxSmall ? 'mx-4' : ''),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push(`/ba/${_ctx.ba.id}/pdf-preview`)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("hzba.buttons.anzeigen")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "expand", "class"])
              ]),
              default: _withCtx(() => [
                (!_ctx.ba?.hasPdfSupport())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.t("hzba.pdf.pdfErstellungNichtSupported")), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["title"]))
          : _createCommentVNode("", true),
        (_ctx.isReadonly)
          ? (_openBlock(), _createBlock(_component_hzba_group, {
              key: 3,
              title: _ctx.t('hzba.vorschau.pdfAnzeigenTitel'),
              "data-cy": "group-pdf-report",
              "hide-progress": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_list, { class: "bg-white boxed-container m-4 p-0" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ba?.berichts, (doc, key) => {
                      return (_openBlock(), _createBlock(_component_ion_item, {
                        key: key,
                        class: "cursor-pointer",
                        "data-cy": "button-previewPdf",
                        onClick: ($event: any) => (_ctx.openBaseModal('pdf.view', { pdf: doc.data }))
                      }, {
                        default: _withCtx(() => [
                          (doc.kennzeichen && doc.kennzeichen.endsWith('-de'))
                            ? (_openBlock(), _createBlock(_component_ion_label, {
                                key: 0,
                                "data-cy": "pdf-report-item"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(doc.titel && doc.titel.de), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (doc.kennzeichen && doc.kennzeichen.endsWith('-en'))
                            ? (_openBlock(), _createBlock(_component_ion_label, {
                                key: 1,
                                "data-cy": "pdf-report-item"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(doc.titel && doc.titel.en), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.chevronForward,
                            size: "large"
                          }, null, 8, ["icon"])
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["title"]))
          : _createCommentVNode("", true),
        (_ctx.ba?.archive)
          ? (_openBlock(), _createBlock(_component_hzba_group, {
              key: 4,
              "data-cy": "group-zip-report",
              title: "ZIP Heizungsbestandsaufnahme",
              "hide-progress": ""
            }, {
              cta: _withCtx(() => [
                _createVNode(_component_AButton, {
                  "btn-primary": "true",
                  shape: "round",
                  href: _ctx.getPhotoUrl(_ctx.ba?.archive),
                  "data-cy": "btn-download-zip-report"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("hzba.buttons.downloaden")), 1)
                  ]),
                  _: 1
                }, 8, ["href"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_hzba_group, {
          title: _ctx.t('hzba.vorschau.hzbaAbschliessen'),
          "hide-progress": ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_ion_grid, { class: "p-0" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, { class: "flex-nowrap d-flex items-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        class: "flex-grow-0 mr-2",
                        "data-cy": "fortschritt"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_progress_indicator, {
                            progress: _ctx.totalProgress === 100 ? 100 : 0
                          }, null, 8, ["progress"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.t("hzba.vorschau.felderAusgefuellt")), 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.totalProgress) + "%", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_row, { class: "flex-nowrap d-flex items-center mt-4" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, { class: "flex-grow-0 mr-2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_progress_indicator, {
                            progress: ((_ctx.ba && _ctx.ba.fazit?.length) ?? 0) > 0 ? 100 : 0
                          }, null, 8, ["progress"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.t("hzba.vorschau.fazit")), 1),
                      _createElementVNode("div", null, [
                        _createVNode(_component_AButton, {
                          "btn-primary": true,
                          "data-cy": "fazit-hinzufuegen",
                          shape: "round",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (
                  _ctx.openBaseModal('conclusion', {
                    parent: () => _ctx.ba,
                    maxFazitLength: 500,
                  })
                ))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(!_ctx.isReadonly
                    ? _ctx.ba && _ctx.ba.fazit && _ctx.ba.fazit.length > 0
                      ? _ctx.t("hzba.buttons.aendern")
                      : _ctx.t("hzba.buttons.hinzufuegen")
                    : _ctx.t("hzba.buttons.anzeigen")), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_row, {
                    class: _normalizeClass(!_ctx.isMaxSmall ? 'flex-nowrap d-flex items-center mt-4' : 'flex items-center mt-4 justify-between')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, { class: "flex-grow-0 mr-2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_progress_indicator, {
                            progress: (_ctx.ba.unterschrifts?.length ?? 0) > 0 ? 100 : 0
                          }, null, 8, ["progress"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.t("hzba.vorschau.unterschrift")), 1),
                      _createElementVNode("div", null, [
                        _createVNode(_component_AButton, {
                          "btn-primary": true,
                          class: _normalizeClass(_ctx.isMaxSmall ? 'flex order-last' : ''),
                          "data-cy": "unterschreiben",
                          shape: "round",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openBaseModal('signandsubmit', { ba: _ctx.ba })))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(!_ctx.isReadonly
                    ? _ctx.t("hzba.buttons.hinzufuegen")
                    : _ctx.t("hzba.buttons.anzeigen")), 1)
                          ]),
                          _: 1
                        }, 8, ["class"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_AButton, {
                shape: "round",
                "btn-primary": true,
                class: "text-lg py-5 px-8",
                disabled: !_ctx.isSubmittable,
                expand: _ctx.isMaxSmall ? 'full' : 'block',
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.finishHzba()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("hzba.buttons.abschliessen")), 1)
                ]),
                _: 1
              }, 8, ["disabled", "expand"]),
              (_ctx.isSubmittable || _ctx.isUploading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploadLanguages, (lang) => {
                      return (_openBlock(), _createBlock(_component_PdfPreviewerAndCreator, {
                        key: lang,
                        ref_for: true,
                        ref: (el) => _ctx.setupPdfViewerRef(el, lang),
                        lang: lang,
                        "download-name": _ctx.downloadName,
                        "go-back-url": _ctx.ba && `/ba/${_ctx.ba.id}`,
                        show: false,
                        "is-upload-mode": true,
                        onPdfAsBlob: (blob) => _ctx.setGeneratedPdfFile(blob, lang)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_PdfTemplates, {
                            ba: _ctx.ba,
                            immobilie: _ctx.immobilie,
                            lang: lang
                          }, null, 8, ["ba", "immobilie", "lang"])
                        ]),
                        _: 2
                      }, 1032, ["lang", "download-name", "go-back-url", "onPdfAsBlob"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["title"])
      ]))
    : _createCommentVNode("", true)
}